import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { RouteService } from '../../service/route.service';
import { environment } from '../../../environments/environment';
import { Toast, ToastComponent } from '../shared/toast/toast.component';
import { API_ENDPOINTS } from '../shared/constants/apiEnpoints';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent {
  @Output() collapsedStateChanged = new EventEmitter<boolean>();
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;

  // variables to show and hide childrens of nav
  activeRoute: string[] = [];
  environment: string = environment.envName;
  isMinimized: boolean = false;
  userRole = localStorage.getItem('userRole');
  homeMenu: boolean = false;
  configurationMenu: boolean = true;
  reportsMenu: boolean = false;
  agentReleaseMenu: boolean = false;
  systemAdministratioMenu: boolean = false;
  isClearing = false;
  isClearCacheConfirmationModalVisible: boolean;
  isLoading: boolean = false;

  constructor(private routeService: RouteService, private http: HttpClient,) { }

  ngOnInit(): void {
    this.getRoutes().then(() => {
      this.toggleByUrl();
    });
  }

  toggleHomeMenu() {
    this.homeMenu = !this.homeMenu;
  }

  toggleConfigurationMenu() {
    this.configurationMenu = !this.configurationMenu;
  }

  openConfigurationMenu() {
    this.configurationMenu = true;
  }

  toggleReportsMenu() {
    this.reportsMenu = !this.reportsMenu;
  }

  toggleAgentReleaseMenu() {
    this.agentReleaseMenu = !this.agentReleaseMenu;
  }

  toggleSystemAdministration() {
    this.systemAdministratioMenu = !this.systemAdministratioMenu;
  }

  async getRoutes() {
    await this.routeService.getRoutes().subscribe((routes) => {
      this.activeRoute = routes;
      this.activeRoute.shift();
    });
  }

  // code to toggle the correct menu item based on url
  toggleByUrl(): void {
    switch (this.activeRoute[1]) {
      case 'configuration':
        this.openConfigurationMenu();
        break;

      case 'reports':
        this.toggleReportsMenu();
        break;

      case 'home':
        this.toggleHomeMenu();
        break;
      case 'manage-agent-releases':
        this.toggleAgentReleaseMenu();
        break;
    }
  }

  toggleSideBar() {
    this.isMinimized = !this.isMinimized;
    this.collapsedStateChanged.emit(this.isMinimized);
  }

  clearServerCache(): void {
    this.isClearCacheConfirmationModalVisible = true;
  }

  handleClearCacheModalAction(action: 'confirm' | 'cancel') {
    this.isClearCacheConfirmationModalVisible = false;
    this.isLoading = true;
    if (action === 'confirm') {
      this.http.post(API_ENDPOINTS.CLEAR_CACHE, {}).subscribe({
        next: (response) => {
          this.isLoading = false;
          var toast: Toast = {
            title: 'Success',
            message: 'The server cache cleared successfully.',
            severity: 'success',
          }
          this.toastComponent.showToast(toast);
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error clearing cache', error);
          var toast: Toast = {
            title: 'Failed',
            message: 'Failed to clear the server cache.',
            severity: 'error'
          }
          this.toastComponent.showToast(toast);
        }
      });
    } else
      this.isLoading = false;
  }
}
